import React from "react";
import { __ } from "@wordpress/i18n";
import { useSelect } from "@wordpress/data";
import {
	Tip,
	PanelBody,
	BaseControl,
	ColorPalette,
	RangeControl,
	ToggleControl,
	__experimentalToggleGroupControl as ToggleGroupControl,
	__experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from "@wordpress/components";

function Inspector(props) {
	const { attributes, setAttributes } = props;
	const { ghubVideoLightbox } = attributes;

	const { defaultColors } = useSelect((select) => {
		return {
			defaultColors:
				select("core/block-editor")?.getSettings()?.__experimentalFeatures
					?.color?.palette?.default,
		};
	});

	const openEffectOptions = [
		{
			value: "none",
			label: __("None", "ghub-youtube-lightbox"),
		},
		{
			value: "zoom",
			label: __("Zoom", "ghub-youtube-lightbox"),
		},
		{
			value: "fade",
			label: __("Fade", "ghub-youtube-lightbox"),
		},
	];

	return (
		<PanelBody
			title={__("Lightbox", "ghub-video-lightbox")}
			initialOpen={false}
		>
			<ToggleControl
				label={__("Lightbox", "ghub-video-lightbox")}
				checked={ghubVideoLightbox}
				onChange={() => {
					setAttributes({ ghubVideoLightbox: !ghubVideoLightbox });
				}}
			/>
			{ghubVideoLightbox && (
				<>
					<Tip>
						{__(
							"This feature will work on frontend make sure you have added poster image.",
							"ghub-video-lightbox"
						)}
					</Tip>
					<br /> <br />
					<ToggleControl
						label={__("Close On Outside Click", "ghub-video-lightbox")}
						checked={attributes.closeOnOutsideClick}
						onChange={() =>
							setAttributes({
								closeOnOutsideClick: !attributes.closeOnOutsideClick,
							})
						}
					/>
					<RangeControl
						label={__("Player Size (%)", "ghub-video-lightbox")}
						value={attributes.playerSize}
						onChange={(newValue) => setAttributes({ playerSize: newValue })}
						min={25}
						max={100}
					/>
					<ToggleGroupControl
						__nextHasNoMarginBottom
						label={__("Effect", "ghub-video-lightbox")}
						value={attributes.lightboxOpenEffect}
						onChange={(newValue) => {
							setAttributes({ lightboxOpenEffect: newValue });
						}}
					>
						{openEffectOptions.map(({ value, label }) => {
							return (
								<ToggleGroupControlOption
									key={value}
									value={value}
									label={label}
								/>
							);
						})}
					</ToggleGroupControl>
					<BaseControl label={__("Overlay Color", "ghub-video-lightbox")}>
						<ColorPalette
							colors={defaultColors}
							enableAlpha
							value={attributes.overlayColor}
							onChange={(newColor) => setAttributes({ overlayColor: newColor })}
						/>
					</BaseControl>
				</>
			)}
		</PanelBody>
	);
}

export default Inspector;
